import { FieldDefinition, FieldBuilder, MENU_CATEGORY_KEY, MENU_NAME_SUFFIX, MenuCategories, MENU_SUBCATEGORY_KEY, MenuSubcategories } from '@zendra/shared';
import { FinalProductService } from '../proxy/general/controllers/final-product.service';
import { SpeciesService } from '../proxy/general/controllers/species.service';
import { LengthService } from '@woodsupply/proxy/wood-supply/controllers';

FieldBuilder.setNamespace('General');

export const WOODPRODUCTDETAIL_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .checkbox('isFscCertified', 'Entity.WoodProductDetail.IsFscCertified')
    .build(),
  FieldBuilder
    .checkbox('isWoodLog', 'Entity.WoodProductDetail.IsWoodLog')
    .build(),
  FieldBuilder
    .number('bdmtMcsFactor', 'Entity.WoodProductDetail.BdmtMcsFactor')
    .required()
    .decimal()
    .build(),
  FieldBuilder
    .checkbox('isPefcCertified', 'Entity.WoodProductDetail.IsPefcCertified')
    .build(),
  FieldBuilder
    .foreignKey('speciesId', 'Entity.Species', SpeciesService)
    .required()
    .displayFromNested('species.name') 
    .sortBy('species.name') 
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('lengthId', 'Entity.Length', LengthService)
    .required()
    .display('value')  
    .keyField('id') 
    .build(),
  FieldBuilder
    .foreignKey('finalProductId', 'Entity.FinalProduct', FinalProductService)
    .required()
    .displayFromNested('finalProduct.name') 
    .sortBy('finalProduct.name')
    .hideInChildForms()
    .build(),
];

export const WOODPRODUCTDETAIL_CONFIG = {
  entityName: 'WoodProductDetail',
  localizationKey: 'General::Entity.WoodProductDetail',
  fields: WOODPRODUCTDETAIL_FIELDS,
  permission: 'GeneralFinalProduct.WoodProductDetails',
    showInMenu: true,
    menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
    menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.FinalProduct + MENU_NAME_SUFFIX,
};
